import { render, staticRenderFns } from "./Block_Turnstile.vue?vue&type=template&id=b14ded12"
import script from "./Block_Turnstile.vue?vue&type=script&lang=js"
export * from "./Block_Turnstile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports